import {NetworkAPIVersion, NetworkParamType} from './network.utils';

export default {
  list: {
    url: 'owned-clan-pedigree/',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
    params: {
      limit: [NetworkParamType.number],
      offset: [NetworkParamType.number],
      user_tree_id: [NetworkParamType.number],
    },
  },
};
